/* eslint-disable no-undef */
import 'vendor.jquery';
import 'vendor.js-cookie';
import fancyBox from 'vendor.fancybox';
if (!$.fancybox) fancyBox();

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.section = this.querySelector('.newsletter-popup');
    this.newsletter_popup_seconds = parseInt(
      this.section.dataset.newsletterPopupSeconds,
      10
    );
    this.newsletter_popup_days = parseInt(
      this.section.dataset.newsletterPopupDays,
      10
    );
    this.newsletter_popup_mobile = this.section.dataset.newsletterPopupMobile;
    this.cookie_enabled = this.newsletter_popup_days != 0 ? true : false;

    const popup = window.Cookies.get('popup');
    if (!(this.cookie_enabled && popup == 'open')) {
      this.open();
    }
  }

  open() {
    if (
      !(
        this.newsletter_popup_mobile ||
        window.PXUTheme.media_queries.large.matches
      )
    )
      return;

    setTimeout(() => {
      $.fancybox.open($(this.section), {
        baseClass: 'newsletter-lightbox',
        hash: false,
        infobar: false,
        toolbar: false,
        loop: true,
        smallBtn: true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        afterShow: () => {
          if (this.cookie_enabled) this.setCookie();
        },
      });
    }, this.newsletter_popup_seconds * 1000);
  }

  setCookie() {
    window.Cookies.set('popup', 'open', {
      expires: this.newsletter_popup_days,
      path: '',
      domain: '',
      sameSite: 'None',
      secure: true,
    });
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
